import { WidgetProps } from "@rjsf/utils";

import { useUser } from "@/providers/auth-provider";
import { useOrganisationsListAllPagesQuery } from "@/queries/query-organisations";

export const OrganisationSelect = ({ schema, uiSchema: _uiSchema, ...rest }: WidgetProps) => {
  const { ui: field, ...uiSchema } = _uiSchema || {};
  const { registry } = rest;
  const { data, isLoading } = useOrganisationsListAllPagesQuery();
  const organisations = data?.results ?? [];
  const { EnumOrInput } = registry.widgets;
  const { kvk } = useUser();

  return (
    <EnumOrInput
      {...rest}
      isLoading={isLoading}
      schema={{
        ...schema,
        default: kvk,
        enum: organisations.map((option) => option.kvkNumber),
      }}
      uiSchema={{
        ...uiSchema,
        "ui:enumNames": organisations.map((option) => option.name),
      }}
    />
  );
};
